(() => {
  'use strict';

  let specRootIndex = 0;

  function syncSpecAccordion(item, index, rootId) {
    const button = item.querySelector('.spec-header');
    const content = item.querySelector('.spec-content');
    if (!button || !content) return;

    if (!content.id) content.id = `product-spec-content-${rootId}-${index + 1}`;
    button.setAttribute('aria-controls', content.id);
    button.setAttribute('aria-expanded', String(item.classList.contains('active')));
  }

  class WatchSpecs extends HTMLElement {
    constructor() {
      super();
      this.rootId = ++specRootIndex;
      this.addEventListener('click', this.toggleAccordion);
    }

    connectedCallback() {
      this.querySelectorAll('.spec-item-accordion').forEach((item, index) => {
        syncSpecAccordion(item, index, this.rootId);
      });
    }

    toggleAccordion(event) {
      const button = event.target.closest?.('.spec-header');
      const item = button?.closest('.spec-item-accordion');
      if (!item || item.closest('specht-watch-specs') !== this) return;
      const open = !item.classList.contains('active');
      this.querySelectorAll('.spec-item-accordion.active').forEach((previous) => {
        previous.classList.remove('active');
        previous.querySelector('.spec-header')?.setAttribute('aria-expanded', 'false');
      });
      if (open) {
        item.classList.add('active');
        button.setAttribute('aria-expanded', 'true');
      }
    }
  }

  function patchLaiReviewLocale(helpfulLabel) {
    if (!helpfulLabel || typeof scmLanguage !== 'string' || !scmLanguage.includes('Translation missing')) {
      return false;
    }
    scmLanguage = scmLanguage.replace(
      /"helpful":\s*"Translation missing:[^"]*"/,
      '"helpful": ' + JSON.stringify(helpfulLabel)
    );
    return !scmLanguage.includes('Translation missing');
  }

  function initLaiReviewLocale() {
    const script = document.querySelector('script[data-lai-helpful][src*="product-quality"]');
    const helpfulLabel = script?.getAttribute('data-lai-helpful');
    if (!helpfulLabel) return;

    if (patchLaiReviewLocale(helpfulLabel)) return;

    const stop = () => observer.disconnect();
    const tryPatch = () => patchLaiReviewLocale(helpfulLabel);
    const observer = new MutationObserver(() => {
      if (tryPatch()) stop();
    });
    observer.observe(document.head, { childList: true, subtree: true });
    setTimeout(stop, 5000);
    document.addEventListener('DOMContentLoaded', tryPatch, { once: true });
  }

  function init() {
    if (!customElements.get('specht-watch-specs')) customElements.define('specht-watch-specs', WatchSpecs);
    initLaiReviewLocale();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
